import { Type, string, number, boolean } from "js-validate-type";

let token = null;

export default function API(base_url) {
    async function authenticate(name, brand, secret) {
        new Type({
            name: string,
            brand: string,
            secret: string,
        }).assert({ name, brand, secret });

        const url = `${base_url}/authenticate/service`;
        const resp = await fetch_url(url, "POST", { name, brand, secret });
        token = resp.token;
        return resp;
    }

    function get_jackpot_for_source(brandId, sourceId, playerId, country) {
        new Type({
            brandId: string,
            sourceId: string,
            playerId: string,
            country: string,
        }).assert({ brandId, sourceId: sourceId, playerId, country });

        let url = `${base_url}/jackpots/instances/source/${sourceId}/brand/${brandId}?`;
        if (country) {
            url += `country=${country}&`;
        }
        if (playerId) {
            url += `player_id=${playerId}`;
        }
        return fetch_url(url);
    }

    function get_sources(brandIds) {
        if (!Array.isArray(brandIds)) {
            brandIds = [brandIds];
        }
        new Type({
            brandIds: [string],
        }).assert({ brandIds });

        let url = `${base_url}/sources?`;
        for (const brandId of brandIds) {
            url += `owner_id=${brandId}&`;
        }
        return fetch_url(url);
    }

    function opt_in_out(payload) {
        new Type({
            instance_id: string,
            brand_id: string,
            player_id: string,
            player_country: string,
            opt_in: boolean,
        }).assert(payload);

        const url = `${base_url}/jackpots/optinout`;
        return fetch_url(url, "POST", payload);
    }

    function contribute(payload) {
        new Type({
            token: string,
            wallet_id: string,
            brand_id: string,
            source_id: string,
            gameround_id: string,
            player_id: string,
            player_country: string,
            base_wager: number,
            currency: string,
        }).assert(payload);

        const url = `${base_url}/jackpots/contribute/source`;
        return fetch_url(url, "POST", payload);
    }

    return {
        authenticate,
        get_jackpot_for_game: get_jackpot_for_source,
        get_sources: get_sources,
        opt_in_out,
        contribute,
    };
}

async function fetch_url(url, method, payload) {
    let headers = {
        "Content-Type": "application/json"
    };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    let resp = await fetch(url, {
        method: method || "GET",
        cache: "no-cache",
        headers,
        body: JSON.stringify(payload)
    });

    const contentType = resp.headers.get("Content-Type");
    const isJson = contentType && contentType.startsWith("application/json");
    const data = isJson ? resp.json() : await resp.text();

    if (resp.ok) {
        return data;
    } else {
        throw new Error(`${resp.status} ${resp.statusText} ${data}`);
    }
}
